import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["children", "buttonUse", "option", "multi"];
import UIButton from 'UIComponents/button/UIButton';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { TruncateString } from 'foundations-components/transitional/components/TruncateString';
import { View } from 'foundations-components/components/View';
import { ColorSquatch } from 'foundations-components/transitional/components/ColorSquatch';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export default function CampaignSelectItemComponent(_ref) {
  let {
      children,
      buttonUse,
      option,
      multi
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  if (option.buttonText && option.dropdownText || option.options ||
  // isSpecial cases are for built in functionality like the load more / loading rows.
  option.isSpecial) {
    // If the option is a built in one, we simply return the children wrapped in a span
    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      children: children
    }));
  }
  const truncateOptionValue = !option.isInTree && buttonUse === 'transparent' ? {
    maxWidth: 200
  } : undefined;
  const shouldTruncate = option.isInTree || !multi;
  const optionContent = /*#__PURE__*/_jsxs(TFlex, {
    align: "center",
    children: [(option.isInTree || option.colorHex) && /*#__PURE__*/_jsx(View, {
      display: "inline-block",
      marginInlineEnd: "200",
      inlineSize: "8px",
      blockSize: "8px",
      borderRadius: "full",
      overflow: "hidden",
      children: /*#__PURE__*/_jsx(ColorSquatch, {
        "data-test-property-name": `campaign-color-dot-${option.value}`,
        color: option.colorHex,
        size: 14,
        margin: "-100"
      })
    }), shouldTruncate ? /*#__PURE__*/_jsx(TruncateString, Object.assign({
      "data-test-id": 'campaign-truncate'
    }, truncateOptionValue, {
      children: option.text || option.value
    })) : option.text || option.value]
  });
  if (!option.isInTree) {
    return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
      children: optionContent
    }));
  }
  return /*#__PURE__*/_jsx("span", Object.assign({}, rest, {
    children: /*#__PURE__*/_jsx(UIButton, {
      className: "p-left-1",
      title: option.text,
      use: "unstyled",
      children: optionContent
    })
  }));
}